import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetOrgUnitContactsData from './GetOmeMeetOrgUnitContactsData';
import postOmeMeetOrgUnitContactData from './PostOmeMeetOrgUnitContactData';
import putOmeMeetOrgUnitContactData from './PutOmeMeetOrgUnitContactData';
import deleteOmeMeetOrgUnitContactData from './DeleteOmeMeetOrgUnitContactData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetOrgUnitContactData = {
  INITIAL_STATE, getOmeMeetOrgUnitContactsData, postOmeMeetOrgUnitContactData,
  putOmeMeetOrgUnitContactData, deleteOmeMeetOrgUnitContactData
};

export default OmeMeetOrgUnitContactData;